import { mapLocaleToIetfBcp47Format } from '@/shared/utility';
import { envIsCanada, envIsMexico } from '@/constants/constants';

export const formatCurrency = (
  amount: number,
  locale: string,
  currency: string,
  fractionDigits = 2,
): string => {
  return new Intl.NumberFormat(mapLocaleToIetfBcp47Format(locale), {
    style: 'currency',
    currency,
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(amount);
};

export const formatTransactionHistoryTableCurrency = (
  amount: number,
  currency: string,
  locale: string,
) => (amount > 0 ? formatCurrency(amount, locale, currency, 2) : '-');

export const getCurrencyCodeForLocale = (locale: string): string => {
  if (locale === 'ae') {
    return 'USD';
  }
  if (locale === 'ca' || locale === 'ca-fr' || envIsCanada()) {
    return 'CAD';
  }
  if (locale === 'nz') {
    return 'NZD';
  }
  if (locale === 'za') {
    return 'ZAR';
  }
  if (locale === 'th') {
    return 'THB';
  }
  if (envIsMexico()) {
    return 'MXN';
  }

  return 'EUR';
};
